'use client'

import AdBannerWrapper from '@/components/_cards/ad/ad-banner-wrapper'
import MobileAdBannerWrapper from '@/components/_cards/ad/mobile-ad-banner-wrapper'
import useMysteryTrackRevealRefresh from '@/hooks/use-mystery-track-reveal-refresh'
import apiFetch from '@/store/helpers/api-fetch'
import { useState } from 'react'
import useSWR from 'swr'
import ScheduledPreviewBanner from '../../components/scheduled-preview-banner'
import ChampionshipEventContent from './championship-event-content'
import EventHeader from './event-header'
import SingleEventTabsSection from './single-event-tabs-section'

export default function EventPage({
  event,
  isFinished,
  params,
  searchParams,
  session,
  bannerAd,
  mobileBannerAd,
}) {
  useMysteryTrackRevealRefresh(event)
  const championshipSplits = Array.isArray(event?.championship?.splits)
    ? event.championship.splits
    : []

  const [selectedSplits, setSelectedSplits] = useState(
    championshipSplits.map((s) => s.id),
  )

  const {
    data: eventDrivers,
    isLoading: eventDriversLoading,
    mutate: mutateEventDrivers,
  } = useSWR(
    {
      url: `community/${event.championship.communityId}/championship/${event.championshipId}/event/${event.id}/attendee`,
      searchParams: {
        where: {
          role: {
            in: ['driver', 'reserve'],
          },
          status: 'registered',
        },
        include: {
          user: {
            include: {
              connectedAccounts: true,
              attendingChampionships: {
                where: {
                  championshipId: event.championshipId,
                },
                include: {
                  carClass: true,
                  split: true,
                },
              },
            },
          },
        },
      },
    },
    apiFetch,
  )

  return (
    <>
      <EventHeader
        {...{
          event,
          eventDrivers,
          eventDriversLoading,
          mutateEventDrivers,
          isFinished,
          params,
          session,
        }}
      />

      <ScheduledPreviewBanner championship={event.championship} />

      {/* Banner Ad */}
      {bannerAd && (
        <div className="mt-6 desktop-xs:mt-8">
          <AdBannerWrapper
            ad={bannerAd}
            placement="event-page-banner"
            index={0}
          />
        </div>
      )}

      {/* Mobile Banner Ad */}
      {mobileBannerAd && (
        <div className="mt-6 desktop-xs:mt-8">
          <MobileAdBannerWrapper
            ad={mobileBannerAd}
            placement="event-page-mobile-banner"
            index={0}
          />
        </div>
      )}

      {event.championship.isSingleEvent ? (
        <SingleEventTabsSection
          {...{
            event,
            searchParams,
            params,
            eventDrivers,
            eventDriversLoading,
            selectedSplits,
            setSelectedSplits,
            session,
          }}
        />
      ) : (
        <ChampionshipEventContent
          {...{
            event,
            isFinished,
            selectedSplits,
            setSelectedSplits,
            params,
            session,
            eventDrivers,
            eventDriversLoading,
            mutateEventDrivers,
          }}
        />
      )}
    </>
  )
}
